import { EditorContent, useEditor } from '@tiptap/react'
import React, { useEffect } from 'react'

import { createRichTextExtensions } from './extensions'
import './style.scss'

interface RichTextViewerProps {
  /** HTML produced by RichTextEditor */
  value: string
}

/** Read-only rendering through the editor schema, so stored HTML is never injected as-is */
const RichTextViewer: React.FC<RichTextViewerProps> = ({ value }) => {
  const editor = useEditor({
    extensions: createRichTextExtensions(),
    content: value,
    editable: false,
  })

  useEffect(() => {
    editor.commands.setContent(value, { emitUpdate: false })
  }, [editor, value])

  return <EditorContent editor={editor} className="rich-text-content" />
}

export default RichTextViewer
